// extracted by mini-css-extract-plugin
export default {"privacy":"social-blocks-ImportantBlockUserInfo__privacy--1IWLH"};